import React from 'react'
import { useLocation } from 'react-router-dom'
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core'
import DashboardIcon from '@material-ui/icons/Dashboard'
import WarningIcon from '@material-ui/icons/Warning'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import PersonIcon from '@material-ui/icons/Person'
import { useAuth } from '../../modules/security/containers/AuthProvider'
import Link from '../Link'
import uuid from '../../utils/random'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import UserGuide from '@material-ui/icons/UserGuide'
import Flag from '@material-ui/icons/Flag'

//
// import PanToolSharpIcon from '@mui/icons-material/PanToolSharp'
import PanToolSharpIcon from '@material-ui/icons/PanToolSharp'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: clsx(
      document.getElementsByTagName('html')[0].getAttribute('dir') === 'ltr'
        ? '91%'
        : '90%',
    ),
    position: 'sticky',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      position: 'sticky',
    },
  },
  selectedListItem: {
    backgroundColor: `${theme.palette.primary.main}!important`,
    color: `${theme.palette.primary.contrastText}!important`,
    // the fill is added to be inherited by icons on list items (must be same as color)
    fill: `${theme.palette.primary.contrastText}!important`,
  },
}))
const ListItems = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { hasRoles, logout, me } = useAuth()
  const { pathname } = useLocation()

  return (
    <div className={classes.root}>
      <div>
        {hasRoles(['administrator', 'supervisor', 'seniorIntervenor']) && (
          <div>
            <ListItem
              selected={pathname === '/app/dashboard'}
              button
              classes={{ selected: classes.selectedListItem }}
              component={Link}
              to={{ pathname: '/app/dashboard', state: { refreshId: uuid() } }}
              underline="none"
            >
              <ListItemIcon>
                <DashboardIcon style={{ fill: 'inherit' }} />
              </ListItemIcon>
              <ListItemText primary={t('listItems.dashboard')} />
            </ListItem>
          </div>
        )}

        {hasRoles(['administrator', 'supervisor', 'seniorIntervenor']) && (
          <ListItem
            selected={pathname === '/app/complaints'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/app/complaints', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <WarningIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.reclamations')} />
          </ListItem>
        )}

        {hasRoles(['administrator', 'supervisor']) && (
          <ListItem
            selected={pathname === '/app/contributors'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/app/contributors', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <PersonIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.utilisateurs')} />
          </ListItem>
        )}

        {/* -----------------------------------Intervenant Roles content ------------------------------------------------- */}
        
        {hasRoles(['intervenor']) && (
          <div>
            <ListItem
              selected={pathname === '/intervenor/dashboard'}
              button
              classes={{ selected: classes.selectedListItem }}
              component={Link}
              to={{ pathname: '/intervenor/dashboard', state: { refreshId: uuid() } }}
              underline="none"
            >
              <ListItemIcon>
                <DashboardIcon style={{ fill: 'inherit' }} />
              </ListItemIcon>
              <ListItemText primary={t('listItems.dashboard')} />
            </ListItem>
          </div>
        )}

        {hasRoles(['intervenor']) && (
          <div>
            <ListItem
              selected={pathname === '/intervenor/assignedComplaints'}
              button
              classes={{ selected: classes.selectedListItem }}
              component={Link}
              to={{
                pathname: '/intervenor/assignedComplaints',
                state: { refreshId: uuid() },
              }}
              underline="none"
            >
              <ListItemIcon>
                <WarningIcon style={{ fill: 'inherit' }} />
              </ListItemIcon>
              <ListItemText primary={t('listItems.assignedComplaints')} />
            </ListItem>
          </div>
        )}

        {hasRoles(['intervenor']) && me?.entityType != 10 && me?.entityType != 9 && (
          <div>
            <ListItem
              target="_blank"
              href="https://ndif-portal.witrack.digital/UploadedUserGuides/guide.pdf"
              // selected={pathname === '/intervenant/guidePDF'}
              button
              classes={{ selected: classes.selectedListItem }}
              component="a"
              // to={{ pathname: '/intervenant/guidePDF' }}
              underline="none"
            >
              <ListItemIcon>
                <UserGuide style={{ fill: 'inherit' }} />
              </ListItemIcon>
              <ListItemText primary={t('listItems.guide')} />
            </ListItem>
          </div>
        )}

        {hasRoles(['intervenor']) && (me?.entityType == 10 || me?.entityType == 9) && (
          <div>
            <ListItem
              target="_blank"
              href="https://ndif-portal.witrack.digital/UploadedUserGuides/guide_wilaya.pdf"
              // selected={pathname === '/intervenant/guidePDF'}
              button
              classes={{ selected: classes.selectedListItem }}
              component="a"
              // to={{ pathname: '/intervenant/guidePDF' }}
              underline="none"
            >
              <ListItemIcon>
                <UserGuide style={{ fill: 'inherit' }} />
              </ListItemIcon>
              <ListItemText primary={t('listItems.guide')} />
            </ListItem>
          </div>
        )}
        {/* -----------------------------------------end of intervenant Roles content-------------------------------------------------------------------- */}

        {/* this is the Intervenant page that the Admin can see ---------------------------------------------------------*/}
        {hasRoles(['administrator', 'seniorIntervenor']) && (
          <ListItem
            selected={pathname === '/app/intervenant'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/app/intervenant', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <PanToolSharpIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.intervenants')} />
          </ListItem>
        )}
        {/* end of intervernant Page---------------------------------------------------------------------------- */}

        {hasRoles(['administrator']) && (
          <ListItem
            selected={pathname === '/app/supervisor'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/app/supervisor', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <SupervisorAccountIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.administration')} />
          </ListItem>
        )}

        {hasRoles(['administrator']) && (
          <ListItem
            selected={pathname === '/app/AddPDF'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/app/AddPDF', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <UserGuide style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.guide')} />
          </ListItem>
        )}

        {hasRoles(['challengeSupervisor']) && (
          <ListItem
            selected={pathname === '/challenge/challengeParticipationsDashboard'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/challenge/challengeParticipationsDashboard', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <DashboardIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.dashboard')} />
          </ListItem>
        )}

        {hasRoles(['challengeSupervisor']) && (
          <ListItem
            selected={pathname === '/challenge/challengeParticipations'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to={{ pathname: '/challenge/challengeParticipations', state: { refreshId: uuid() } }}
            underline="none"
          >
            <ListItemIcon>
              <Flag style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.challengeParticipations')} />
          </ListItem>
        )}
      </div>
      {/* profil related links on the bottom of the drawer */}
      <div>
        {hasRoles(['administrator', 'supervisor', 'seniorIntervenor']) && (
          <ListItem
            selected={pathname === '/app/change-password'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to="/app/change-password"
            underline="none"
          >
            <ListItemIcon>
              <AccountBoxIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.profile')} />
          </ListItem>
        )}
        {hasRoles(['intervenor']) && (
          <ListItem
            selected={pathname === '/intervenant/change-password'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to="/intervenor/change-password"
            underline="none"
          >
            <ListItemIcon>
              <AccountBoxIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.profile')} />
          </ListItem>
        )}
        {hasRoles(['challengeSupervisor']) && (
          <ListItem
            selected={pathname === '/challenge/change-password'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to="/challenge/change-password"
            underline="none"
          >
            <ListItemIcon>
              <AccountBoxIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.profile')} />
          </ListItem>
        )}
        {/* <ListItem
            selected={pathname === '/app/change-password'}
            button
            classes={{ selected: classes.selectedListItem }}
            component={Link}
            to="/app/change-password"
            underline="none"
          >
            <ListItemIcon>
              <AccountBoxIcon style={{ fill: 'inherit' }} />
            </ListItemIcon>
            <ListItemText primary={t('listItems.profile')} />
          </ListItem> */}

        <ListItem button onClick={logout}>
          <ListItemIcon>
            <PowerSettingsNewIcon />
          </ListItemIcon>
          <ListItemText primary={t('listItems.deconnecter')} />
        </ListItem>
      </div>
    </div>
  )
}
export default ListItems
